import ConsultaPerfisAdmin from './ConsultaPerfisAdmin'
import enhancer from './ConsultaPerfisAdmin.enhancer'

export default enhancer(ConsultaPerfisAdmin)


// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConsultaPerfisAdmin/index.js